module.exports = __webpack_public_path__ + "static/deer-portal-3083d8cadcbf0e90b50cd064f537403c.jpg";